// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_aa-0";
export var optionCard = "_aa-1";